import React, { useEffect } from 'react';

import { focusElement } from 'platform/utilities/ui';

import BreadCrumbs from '../components/BreadCrumbs';
import EnvironmentBanner from '../components/EnvironmentBanner';
import NeedHelpFooter from '../components/NeedHelpFooter';
import AskVaLinkWithRouter from '../components/AskVaLink';

const ResponseSentPage = () => {
  useEffect(() => {
    focusElement('#response-sent-alert');
  }, []);

  return (
    <div className="row vads-u-padding-x--1">
      <EnvironmentBanner />
      <BreadCrumbs currentPath="/response-sent" />
      <div className="usa-width-two-thirds medium-8 columns vads-u-padding--0">
        <h1 className="vads-u-margin-bottom--5">Response sent</h1>
        <va-alert id="response-sent-alert" status="success" visible slim>
          <p className="vads-u-margin-y--0">
            Your response was submitted successfully.
          </p>
        </va-alert>

        <p className="vads-u-margin-bottom--3 vads-u-margin-top--3">
          Thank you for sending a response. Your question has now been reopened.
        </p>
        <p className="vads-u-margin-bottom--3">
          You should receive a reply within 7 business days. If we need more
          information to answer your question, we’ll contact you.
        </p>
        <div className="vads-u-margin-bottom--7 vads-u-margin-top--6">
          <AskVaLinkWithRouter
            href="inbox"
            text="Return to Ask VA inbox"
            variant="action.secondary"
          />
        </div>
        <NeedHelpFooter />
      </div>
    </div>
  );
};

export default ResponseSentPage;
